import { render, staticRenderFns } from "./Home_product.vue?vue&type=template&id=36525641&scoped=true&"
import script from "./Home_product.vue?vue&type=script&lang=js&"
export * from "./Home_product.vue?vue&type=script&lang=js&"
import style0 from "./Home_product.vue?vue&type=style&index=0&id=36525641&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36525641",
  null
  
)

export default component.exports